import React from 'react';
import { Link } from 'react-router-dom';
import { FaMicrochip, FaPlug, FaBoxOpen, FaVials, FaRobot, FaSearch } from 'react-icons/fa';
import PageHero from '../components/PageHero';

// const caps = [
//   {
//     icon: <FaMicrochip size={22}/>,
//     title: 'PCB Assembly (PCBA)',
//     desc: 'Three high-mix, high-volume SMT lines with PanaCIM full traceability software.',
//     specs: [
//       ['SMT Lines','2(Line 2 with PanaCIM- Manufacturing Execution System) '],
//       ['Throughput','1,25,000 CPH '],
//       ['Accuracy','4 Sigma'],
//       ['Min Component','0402 mm (01005")'],
//       ['BGA Capability','Yes — full rework station'],
//       ['Packages','BGA, QFP, QFN, SOP, DIP'],
//     ],
//   },
//   {
//     icon: <FaPlug size={22}/>,
//     title: 'Cable Harness Assembly',
//     desc: 'Automated and manual cable harness for railways, industrial, and defence — high-mix, high-tech.',
//     specs: [
//       ['Wire Diameter','0.14 sq mm – 16 sq mm'],
//       ['Cut Length Range','1 mm – 99,999.9 mm'],
//       ['Pull Test Standard','Per UL 486A'],
//       ['Efficiency','2,000 pcs/hour'],
//       ['Crimp Force','Monitored (HF2000)'],
//       ['Segments','Railway, Industrial, Defence'],
//     ],
//   },
//   {
//     icon: <FaBoxOpen size={22}/>,
//     title: 'Box Build Assembly',
//     desc: 'Complete product integration — PCB, harness, displays, mechanical parts, and EOL testing.',
//     specs: [
//       ['Scope','Full product integration'],
//       ['Enclosures','Plastic & metal'],
//       ['Display Integration','Yes — multi-display'],
//       ['Wiring','In-house harness'],
//       ['Packing','Customer-specific'],
//       ['Testing','EOL functional test'],
//     ],
//   },
//   {
//     icon: <FaVials size={22}/>,
//     title: 'Testing & Validation',
//     desc: 'Inline SPI, AOI, X-ray, ICT, and FCT — with full real-time traceability on every unit.',
//     specs: [
//       ['SPI','Cyberoptics — inline'],
//       ['AOI','Cyberoptics QX600 — inline'],
//       ['X-Ray','BGA inspection capable'],
//       ['ICT','In-circuit testing'],
//       ['FCT','End-of-line functional'],
//       ['Traceability','PanaCIM real-time'],
//     ],
//   },
//   {
//     icon: <FaRobot size={22}/>,
//     title: 'Special Processes',
//     desc: 'Gluing, conformal coating, UL-compliant assembly processes, and in-house jig & fixture development.',
//     specs: [
//       ['Conformal Coating','Spray & manual'],
//       ['Gluing','Various adhesives'],
//       ['UL Assembly','COC & traceability'],
//       ['Jigs & Fixtures','In-house dev'],
//       ['IPC Compliance','Class II & III'],
//       ['Documentation','Full process records'],
//     ],
//   },
//   {
//     icon: <FaSearch size={22}/>,
//     title: 'NPI & Engineering',
//     desc: 'New Product Introduction from DFX review and proto build through to series production handover.',
//     specs: [
//       ['DFX Review','DFM / DFA / DFT'],
//       ['Proto Build','Rapid turnround'],
//       ['Test Fixtures','In-house designed'],
//       ['ECO Management','Full change control'],
//       ['IPC Compliance','Documented process'],
//       ['Handover','Structured NPI gates'],
//     ],
//   },
// ];
const caps = [
  {
    icon: <FaMicrochip size={22}/>,
    title: 'PCB Assembly (PCBA)',
    desc: 'Three high-mix, high-volume SMT lines with PanaCIM full traceability software.',
    bg: 'https://images.pexels.com/photos/7286002/pexels-photo-7286002.jpeg',
    specs: [
      ['SMT Lines','2 (Line 2 with PanaCIM- MES)'],
      ['Throughput','1,25,000 CPH'],
      ['Accuracy','4 Sigma'],
      ['Min Component','0402 mm (01005")'],
      ['BGA Capability','Yes — full rework station'],
      ['Packages','BGA, QFP, QFN, SOP, DIP'],
    ],
  },
  {
    icon: <FaPlug size={22}/>,
    title: 'Cable Harness Assembly',
    desc: 'Automated and manual cable harness for railways, industrial, and defence — high-mix, high-tech.',
    bg: 'https://images.pexels.com/photos/35673089/pexels-photo-35673089.jpeg',
    specs: [
      ['Wire Diameter','0.14 sq mm – 16 sq mm'],
      ['Cut Length Range','1 mm – 99,999.9 mm'],
      ['Pull Test Standard','Per UL 486A'],
      ['Efficiency','2,000 pcs/hour'],
      ['Crimp Force','Monitored (HF2000)'],
      ['Segments','Railway, Industrial, Defence'],
    ],
  },
  {
    icon: <FaBoxOpen size={22}/>,
    title: 'Box Build Assembly',
    desc: 'Complete product integration — PCB, harness, displays, mechanical parts, and EOL testing.',
    bg: 'https://images.pexels.com/photos/37174871/pexels-photo-37174871.jpeg',
    specs: [
      ['Scope','Full product integration'],
      ['Enclosures','Plastic & metal'],
      ['Display Integration','Yes — multi-display'],
      ['Wiring','In-house harness'],
      ['Packing','Customer-specific'],
      ['Testing','EOL functional test'],
    ],
  },
  {
    icon: <FaVials size={22}/>,
    title: 'Testing & Validation',
    desc: 'Inline SPI, AOI, X-ray, ICT, and FCT — with full real-time traceability on every unit.',
    bg: 'https://images.pexels.com/photos/34054464/pexels-photo-34054464.jpeg',
    specs: [
      ['SPI','Cyberoptics — inline'],
      ['AOI','Cyberoptics QX600 — inline'],
      ['X-Ray','BGA inspection capable'],
      ['ICT','In-circuit testing'],
      ['FCT','End-of-line functional'],
      ['Traceability','PanaCIM real-time'],
    ],
  },
  {
    icon: <FaRobot size={22}/>,
    title: 'Special Processes',
    desc: 'Gluing, conformal coating, UL-compliant assembly processes, and in-house jig & fixture development.',
    bg: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&auto=format&fit=crop',
    specs: [
      ['Conformal Coating','Spray & manual'],
      ['Gluing','Various adhesives'],
      ['UL Assembly','COC & traceability'],
      ['Jigs & Fixtures','In-house dev'],
      ['IPC Compliance','Class II & III'],
      ['Documentation','Full process records'],
    ],
  },
  {
    icon: <FaSearch size={22}/>,
    title: 'NPI & Engineering',
    desc: 'New Product Introduction from DFX review and proto build through to series production handover.',
    bg: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&auto=format&fit=crop',
    specs: [
      ['DFX Review','DFM / DFA / DFT'],
      ['Proto Build','Rapid turnround'],
      ['Test Fixtures','In-house designed'],
      ['ECO Management','Full change control'],
      ['IPC Compliance','Documented process'],
      ['Handover','Structured NPI gates'],
    ],
  },
];
const equipment = [
  // { name:'SMT Line 1',              desc:'High-mix, high-volume. Semi-automatic SPI. CPH 125K, 4-sigma accuracy.' },
  { name:'SMT Line 1',              desc:'High-mix, high-volume. Fully inline SPI integration.' },
  { name:'SMT Line 2 (New)',        desc:'PanaCIM traceability software, inline SPI & inline AOI. High-mix high-tech.' },
  { name:'BGA Rework Station',      desc:'Fully automatic visual alignment. PCB up to 670×570 mm. BGA up to 100×100 mm. ±1°C accuracy.' },
  { name:'Cyberoptics SPI',         desc:'High-accuracy solder paste inspection with AI-assisted statistical analysis.' },
  { name:'Cyberoptics QX600 AOI',   desc:'SAM + AI² vision technology. 200 cm²/sec. Handles 0402 mm components. Inline.' },
  { name:'Wire Cutting Machine',    desc:'Model SQ-BJYJ8114-3. 2,000 pcs/hour. 1 mm – 99,999.9 mm cut range.' },
  { name:'Crimp Force Monitor',     desc:'Model HF2000. High-quality bench top crimping with optional crimp force monitoring.' },
  { name:'Pull Test Machine',       desc:'UL 486A standard. Tests 1AWG – 22AWG crimped terminals. Accuracy 0.04 kg.' },
];

export default function Manufacturing() {
  return (
    <div>
      <PageHero
        chip="Manufacturing & Capabilities"
        title="State-of-the-Art Production in Mysore"
        subtitle="172,000 sq. ft. facility equipped for high-mix, high-volume, high-reliability electronics manufacturing — with full PanaCIM traceability."
      />

      {/* Capabilities grid */}
      {/* <section className="sec">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div style={{ marginBottom:40 }}>
            <span className="chip">Core Capabilities</span>
            <h2 className="h2">What We Manufacture</h2>
          </div>
          <div className="g3 reveal">
            {caps.map(c => (
              <div key={c.title} className="card">
                <div className="ib">{c.icon}</div>
                <h3 className="h3">{c.title}</h3>
                <p style={{ fontSize:13, color:'#64748b', lineHeight:1.6, marginBottom:16 }}>{c.desc}</p>
                <div style={{ borderTop:'1px solid #f1f5f9', paddingTop:14, display:'flex', flexDirection:'column', gap:7 }}>
                  {c.specs.map(([k,v]) => (
                    <div key={k} style={{ display:'flex', justifyContent:'space-between', gap:8 }}>
                      <span style={{ fontSize:12, color:'#94a3b8' }}>{k}</span>
                      <span style={{ fontSize:12, fontWeight:600, color:'#334155', textAlign:'right' }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
<section className="sec">
  <div
    className="wrap"
    style={{
      width: '100%',
      maxWidth: '100%',
      padding: '0 24px'
    }}
  >
    <div style={{ marginBottom: 40 }}>
      <span className="chip">Core Capabilities</span>
      <h2 className="h2">What We Manufacture</h2>
    </div>
    <div className="g3 reveal">
      {caps.map(c => (
        <div
          key={c.title}
          className="card"
          style={{
            backgroundImage: `url(${c.bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            overflow: 'hidden',
            border: 'none',
          }}
        >
          {/* Dark gradient — top to bottom for vertical cards */}
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.75) 100%)',
              zIndex: 0,
            }}
          />
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div className="ib">{c.icon}</div>
            <h3 className="h3" style={{ color: '#ffffff', fontWeight: 700, marginBottom: 8 }}>
              {c.title}
            </h3>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, marginBottom: 16, fontWeight: 400 }}>
              {c.desc}
            </p>
            <div
              style={{
                borderTop: '1px solid rgba(255,255,255,0.2)',
                paddingTop: 14,
                display: 'flex',
                flexDirection: 'column',
                gap: 7,
              }}
            >
              {c.specs.map(([k, v]) => (
                <div
                  key={k}
                  style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}
                >
                  <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.65)', fontWeight: 400 }}>
                    {k}
                  </span>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#ffffff', textAlign: 'right' }}>
                    {v}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
      {/* Equipment list */}
      <section className="sec bg-surf">
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div style={{ marginBottom:40 }}>
            <span className="chip">Equipment</span>
            <h2 className="h2">SMT, Cable & Inspection Equipment</h2>
          </div>
          <div className="g3 reveal">
            {equipment.map(eq => (
              <div key={eq.name} className="card" style={{ display:'flex', gap:14, alignItems:'flex-start', padding:'20px 22px' }}>
                <div className="ib-sm" style={{ marginTop:2 }}><FaRobot size={15}/></div>
                <div>
                  <h4 style={{ fontFamily:'Rajdhani', fontSize:16, fontWeight:700, color:'#1a1a2e', marginBottom:4 }}>{eq.name}</h4>
                  <p style={{ fontSize:13, color:'#64748b', lineHeight:1.55 }}>{eq.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Facility bar */}
      <section style={{ background:'#5cb85c', padding:'52px 0' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <div className="g4" style={{ textAlign:'center' }}>
            {[
              { v:'172K', l:'Sq. Ft. Total' },
              { v:'40K+', l:'Production Area' },
              { v:'2',    l:'SMT Lines' },
              { v:'Class II & III', l:'IPC Approved' },
            ].map(s => (
              <div key={s.l}>
                <div style={{ fontFamily:'Rajdhani', fontSize:40, fontWeight:700, color:'#fff', lineHeight:1 }}>{s.v}</div>
                <div style={{ fontSize:13, color:'rgba(255,255,255,0.85)', marginTop:6 }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec-sm" style={{ textAlign:'center' }}>
        <div
  className="wrap"
  style={{
    width: '100%',
    maxWidth: '100%',
    padding: '0 24px'
  }}
>
          <h2 className="h2" style={{ marginBottom:10 }}>Tour our facility</h2>
          <p className="sub" style={{ margin:'0 auto 26px' }}>We welcome customer audits and site visits — contact us to schedule.</p>
          <Link to="/contact" className="btn btn-primary">Schedule a Visit</Link>
        </div>
      </section>
    </div>
  );
}
